<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M16.7071 6.29289C17.0976 6.68342 17.0976 7.31658 16.7071 7.70711L10.7071 13.7071C10.3166 14.0976 9.68342 14.0976 9.29289 13.7071L3.29289 7.70711C2.90237 7.31658 2.90237 6.68342 3.29289 6.29289C3.68342 5.90237 4.31658 5.90237 4.70711 6.29289L10 11.5858L15.2929 6.29289C15.6834 5.90237 16.3166 5.90237 16.7071 6.29289Z"
  />
</svg>
